import { type Api } from '../api'
import { toFulfillment } from './to-fulfillment'

export const toPhotoUrl = (url: string) =>
  url.startsWith('/api/v1/') ? `/api/server/${url.slice('/api/v1/'.length)}` : url

const toYandex = (yandex: Api.Yandex) => ({
  sourceUrl: yandex.source_url,
  rating: yandex.rating,
  ratingCount: yandex.rating_count,
  address: yandex.address,
  syncDate: yandex.sync_date,
  photos: yandex.photos.slice(0, 3).map((photo) => ({
    position: photo.position,
    url: toPhotoUrl(photo.url),
  })),
  reviews: yandex.reviews.map((review) => ({
    position: review.position,
    author: review.author,
    rating: review.rating,
    text: review.text,
    publishedDate: review.published_date,
    sourceUrl: review.source_url,
    externalId: review.external_id,
  })),
})

const toReview = (review: Api.Review) => ({
  id: review.id,
  source: review.source,
  rating: review.rating,
  text: review.text,
  author: review.author,
  telegram: review.telegram,
  publishDate: review.publish_date,
  sourceUrl: review.source_url,
  replyText: review.reply_text,
  replyDate: review.reply_date,
  isMine: review.is_mine,
  pendingRating: review.pending_rating ?? null,
  pendingText: review.pending_text ?? null,
  declineReason: review.decline_reason ?? null,
})

const toStat = (stat: Api.Stat) => ({
  viewCount: stat.view_count,
  viewCountRecent: stat.view_count_recent,
  contactCount: stat.contact_count,
  events: stat.events,
  daily: stat.daily,
})

export const toFulfillmentDetail = (detail: Api.DetailData) => ({
  fulfillment: toFulfillment(detail.fulfillment),
  photos: (detail.photos ?? []).map((photo) => ({
    id: photo.id,
    position: photo.position,
    url: toPhotoUrl(photo.url),
  })),
  yandex: detail.yandex ? toYandex(detail.yandex) : null,
  reviews: (detail.reviews ?? []).map(toReview),
  stat: detail.stat ? toStat(detail.stat) : null,
})

export const toFulfillmentReviews = (reviews: Api.Review[]) => reviews.map(toReview)

export type FulfillmentDetail = ReturnType<typeof toFulfillmentDetail>
export type FulfillmentYandex = NonNullable<FulfillmentDetail['yandex']>
export type FulfillmentYandexReview = FulfillmentYandex['reviews'][number]
export type FulfillmentReview = ReturnType<typeof toReview>
